export default {
    min: 'Value must be >= {min}',
    max: 'Value must be <= {max}'
}
